// Your web app's Firebase configuration
var firebaseConfig = {
	apiKey: 'AIzaSyDEnDFwKV1UHnAGiEQDJzGegbgDMfZy7K0',
	authDomain: 'awesome-apps-hooknews.firebaseapp.com',
	databaseURL: 'https://awesome-apps-hooknews.firebaseio.com',
	projectId: 'awesome-apps-hooknews',
	storageBucket: 'awesome-apps-hooknews.appspot.com',
	messagingSenderId: '47671560799',
	appId: '1:47671560799:web:2b22887565b73ebc5929ea',
	measurementId: 'G-2LW2GXE07C'
}

export default firebaseConfig
